import React from 'react'
import PropTypes from 'prop-types'

const Progress = ({ color, progress, roundedCorners, label = '' }) => {
  const roundedCornersClass = roundedCorners ? ' rounded-r-full' : ''
  const roundedNumber = Math.round((progress + Number.EPSILON) * 100) / 100

  return (
    <div className={'h-full ' + color + roundedCornersClass} style={{ width: progress + '%' }} title={label + ' ' + roundedNumber + '%'} />
  )
}

const ProgressBars = ({ progress }) => {
  const arrayLength = progress.length

  return progress.map((data, i) => <Progress key={i} color={data.color} progress={data.progress} label={data.label} roundedCorners={arrayLength === i + 1} />)
}

function ProgressBar ({ height, progress, classNames, middleIndicator = false }) {
  const className = [
    'bg-gray-200',
    'rounded-full',
    'overflow-hidden',
    'relative',
    'flex',
    height
  ]

  return (
    <div className={className.concat(classNames).join(' ')}>
      <ProgressBars progress={progress} />
      {middleIndicator && <div className={height + ' w-px absolute bg-black left-1/2'} />}
    </div>
  )
}

ProgressBar.defaultProps = {
  height: 'h-2',
  classNames: []
}

ProgressBar.propTypes = {
  /**
     * Controls the height of the progress bar,
     * Prop can be 'h-1, 'h-2', 'h-3' etc. (defaults to h-2)
     */
  height: PropTypes.string,
  /**
     * Controls the progress bar data, must be an array with objects
     * 'color' should be a tailwind bg- color or the custom bg-lines
     * 'progress' should be an integer
     * Example: [{ color: 'bg-primary-500', progress: 50 }]
     */
  progress: PropTypes.array,
  /**
     * Add extra classes to the component
     * Array of strings
     */
  classNames: PropTypes.array
}

export default ProgressBar
